import { Component, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';

@Component({
  selector: 'app-agree-novosib',
  templateUrl: './agree-novosib.component.html',
  styleUrls: ['./agree-novosib.component.scss']
})
export class AgreeNovosibComponent implements OnInit {

  constructor(
    private viewportScroller: ViewportScroller,
  ) { }

  ngOnInit(): void {
    this.toTop();
  }
  toTop() {
    this.viewportScroller.scrollToPosition([0, 0]);
  }
}
